import * as yup from 'yup';

const recoveryFormSchema = yup.object().shape({
  email: yup.string().required().email(),
});

export default recoveryFormSchema;
